const bussinesUnit: string = 'POSL1';
const terminalNumber: number = 1;

export function getNextInvoiceNumberPreview() {
    const year = new Date().getFullYear();
    const office = bussinesUnit ;
  
    const current = localStorage.getItem('invoice_counter');
    const nextNumber = current ? parseInt(current) + 1 : 1;
  
    const formatted = `${String(nextNumber)}/${office}/${terminalNumber}`;
    return formatted;
  }
  
  export function confirmInvoiceNumberUsage() {
    const current = localStorage.getItem('invoice_counter');
    const nextNumber = current ? parseInt(current) + 1 : 1;
    localStorage.setItem('invoice_counter', nextNumber.toString());
  }

  export const updateLocalStorageInvoiceNumber = (parsed: number) =>{
    localStorage.setItem('invoice_counter', parsed.toString());
  }

  export const getPreviousLocalStorageInvoiceNumber = () =>{
    const year = new Date().getFullYear();
    const current = localStorage.getItem('invoice_counter');
    const prevNumber = current ? parseInt(current) - 1 : 1;
    const formatted = `${String(prevNumber)}/${bussinesUnit}/${terminalNumber}`;
    return formatted;
  }

  